<template>
  <layout-basic>
    <div class="container-fluid maxWidthMinHeight">
      <div
        class="info-section"
        :class="{'car-active': viewSelection === constants.viewSelection.Cars}"
      >
        <div
          v-if="viewSelection !== constants.viewSelection.Bookings"
          class="card"
          :class="{'car-active': viewSelection === constants.viewSelection.Cars}"
        >
          <div class="card-header info-sec-header">
            <h4 class="info-sec-heading mb-lg-0 mb-1">
              Cars
            </h4>
            <div class="header-control-wrapper">
              <div
                class="btn-group info-sec-header-space"
                role="group"
              >
                <button
                  type="button"
                  class="btn small-button"
                  :class="{ 'btn-outline-secondary': !filter.isWorking, 'btn-secondary': filter.isWorking }"
                  @click="filter.isWorking = true"
                >
                  Working
                </button>
                <button
                  type="button"
                  class="btn small-button"
                  :class="{ 'btn-outline-secondary': filter.isWorking, 'btn-secondary': !filter.isWorking }"
                  @click="filter.isWorking = false"
                >
                  Non-Working
                </button>
              </div>
              <div
                id="car-type-dropdown"
                class="cars-dropdown info-sec-header-space car-type-dropdown"
              >
                <multiselect
                  v-model="filter.carType"
                  placeholder="Car Type"
                  :options="carTypes"
                  :searchable="false"
                  select-label="✓"
                  deselect-label="✗"
                  selected-label=""
                  class="select-with-symbol"
                >
                  <template
                    slot="option"
                    slot-scope="props"
                  >
                    <div class="d-flex">
                      <div
                        v-if="props.option.type !== 'All'"
                        class="car-type"
                        :style="{'background':props.option.colourCode}"
                      />
                      <span>{{ props.option.type }}</span>
                    </div>
                  </template>
                  <template
                    slot="singleLabel"
                    slot-scope="{ option }"
                  >
                    <div class="d-flex">
                      <div
                        v-if="option.type !== 'All'"
                        class="car-type"
                        :style="{'background':option.colourCode}"
                      />
                      <span>{{ option.type }}</span>
                    </div>
                  </template>
                </multiselect>
              </div>
              <div
                id="car-status-dropdown"
                class="cars-dropdown info-sec-header-space car-status-dropdown"
              >
                <multiselect
                  v-model="filter.dispatchStatus"
                  placeholder="Status"
                  :options="dispatchStatuses"
                  :searchable="false"
                  select-label="✓"
                  deselect-label="✗"
                  selected-label=""
                  class="select-with-symbol"
                >
                  <template
                    slot="option"
                    slot-scope="props"
                  >
                    <div class="d-flex">
                      <div
                        v-if="props.option !== -1"
                        class="alert car-msg-status"
                        :class="{'alert-light': props.option === constants.bookingDispatchStatus.Unsent,
                                 'alert-secondary': props.option === constants.bookingDispatchStatus.Sent,
                                 'alert-primary': props.option === constants.bookingDispatchStatus.Delivered,
                                 'alert-success': props.option === constants.bookingDispatchStatus.Accepted}"
                        role="alert"
                      >
                        {{ props.option === -1 ? 'All' : '' }}
                        {{ props.option === constants.bookingDispatchStatus.Unsent ? 'U' : '' }}
                        {{ props.option === constants.bookingDispatchStatus.Sent? 'S' : '' }}
                        {{ props.option === constants.bookingDispatchStatus.Delivered ? 'D' : '' }}
                        {{ props.option === constants.bookingDispatchStatus.Accepted ? 'A' : '' }}
                      </div>
                      <span>{{ props.option === -1 ? 'All' : '' }}</span>
                      <span>{{ props.option === constants.bookingDispatchStatus.Unsent ? 'Unsent' : '' }}</span>
                      <span>{{ props.option === constants.bookingDispatchStatus.Sent? 'Sent' : '' }}</span>
                      <span>{{ props.option === constants.bookingDispatchStatus.Delivered ? 'Delivered' : '' }}</span>
                      <span>{{ props.option === constants.bookingDispatchStatus.Accepted ? 'Accepted' : '' }}</span>
                    </div>
                  </template>
                  <template
                    slot="singleLabel"
                    slot-scope="{ option }"
                  >
                    <div class="d-flex">
                      <div
                        v-if="option !== -1"
                        class="alert car-msg-status"
                        :class="{'alert-light': option === constants.bookingDispatchStatus.Unsent,
                                 'alert-secondary': option === constants.bookingDispatchStatus.Sent,
                                 'alert-primary': option === constants.bookingDispatchStatus.Delivered,
                                 'alert-success': option === constants.bookingDispatchStatus.Accepted}"
                        role="alert"
                      >
                        {{ option === -1 ? 'All' : '' }}
                        {{ option === constants.bookingDispatchStatus.Unsent ? 'U' : '' }}
                        {{ option === constants.bookingDispatchStatus.Sent? 'S' : '' }}
                        {{ option === constants.bookingDispatchStatus.Delivered ? 'D' : '' }}
                        {{ option === constants.bookingDispatchStatus.Accepted ? 'A' : '' }}
                      </div>
                      <span>{{ option === -1 ? 'All' : '' }}</span>
                      <span>{{ option === constants.bookingDispatchStatus.Unsent ? 'Unsent' : '' }}</span>
                      <span>{{ option === constants.bookingDispatchStatus.Sent? 'Sent' : '' }}</span>
                      <span>{{ option === constants.bookingDispatchStatus.Delivered ? 'Delivered' : '' }}</span>
                      <span>{{ option === constants.bookingDispatchStatus.Accepted ? 'Accepted' : '' }}</span>
                    </div>
                  </template>
                </multiselect>
              </div>
              <form class="info-sec-header-space fb-100">
                <b-input
                  v-model="carSearch"
                  class="form-control small-control"
                  placeholder="Search cars..."
                  debounce="300"
                />
              </form>
              <b-button
                v-b-modal.car-modal
                class="small-button info-sec-header-space"
                variant="primary"
              >
                + New Car
              </b-button>
              <b-button
                class="small-button info-sec-header-space"
                variant="info"
                :disabled="!activeCarId"
                @click="editCarModalOpen=true"
              >
                Open
              </b-button>
              <b-button
                class="small-button info-sec-header-space"
                variant="danger"
                :disabled="!activeCarId"
                @click="deleteActiveCar"
              >
                Delete
              </b-button>
              <car-modal @close="onCarModalClose"/>
            </div>
          </div>
          <div
            class="cars-container m-1"
            :class="[{'car-active': viewSelection === constants.viewSelection.Cars},{'cars-two-rows': viewSelection === constants.viewSelection.TwoRowsOfCars}]"
          >
            <div
              v-for="car in cars"
              :key="car.id"
              @dragover.prevent
            >
              <draggable
                :list="bookingsDraggedOnCars[car.id]"
                handle=".fake-handle"
                :sort="false"
                group="bookings"
                @change="onBookingsChange"
              >
                <div class="fake-handle"/>
                <car-card
                  :id="car.id"
                  :name="`${car.driver.firstName} ${car.driver.lastName}`"
                  :is-working="car.isWorking"
                  :car-type="car.carType"
                  :booking="bookingsByCars[car.id] ? bookingsByCars[car.id][0]:null"
                  :is-active="activeCarId === car.id"
                  :clear-callback="clearBooking"
                  @toggle="toggleCarCard(car.id)"
                  @car-working-change="onCarWorkingChange(car)"
                />
              </draggable>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="viewSelection === constants.viewSelection.All"
        class="info-section"
      >
        <div class="card alloc-container">
          <div
            v-for="booking in activeCarBookings"
            :key="booking.id"
            class="card alloc-card"
            :class="{accepted: booking.status === constants.bookingStatus.Accepted}"
          >
            <div class="alloc-info">
              <div
                class="alloc-item time"
                :class="{'text-danger':bookingsShouldBeAlerted[booking.id]}"
              >
                <i class="far fa-clock"/>{{ booking.date | formatDate }}
              </div>
              <div class="alloc-item">
                <i class="far fa-user"/> {{ booking.passengerName }}
              </div>
              <a
                href="#"
                class="table-edit alloc"
                @click="editBooking(booking)"
              >
                <i
                  class="fa fa-external-link-alt"
                /></a>
              <div class="alloc-item address">
                <i class="fa fa-user-plus"/> {{ booking.addressFrom | formatAddress }}
              </div>
              <div class="alloc-item address">
                <i class="fa fa-map-marker-alt"/> {{ booking.addressTo | formatAddress }}
              </div>
            </div>
            <div class="alloc-actions">
              <a
                v-if="booking.status === constants.bookingStatus.Booked"
                href="#"
                class="btn btn-success"
                @click="allocateBooking(booking)"
              >
                <i class="fa fa-clipboard-list"/>
              </a>
              <a
                v-if="booking.status !== constants.bookingStatus.Booked"
                href="#"
                class="btn btn-primary"
                @click="deallocateBooking(booking)"
              >
                <i class="fa fa-undo-alt"/>
              </a>
              <b-button
                class="btn btn-info"
                :disabled="booking.status === constants.bookingStatus.Accepted"
                :class="{disabled: booking.status !== constants.bookingStatus.Allocated}"
                @click="dispatchModal(booking)"
              >
                <i class="fa fa-comment"/>
              </b-button>
            </div>
          </div>
          <dispatch-modal
            :form="dispatchModalForm"
            :open="dispatchModalOpen"
            @modal-closed="dispatchModalOpen = false"
          />
        </div>
      </div>
      <div
        v-if="viewSelection !== constants.viewSelection.Cars"
        class="info-section bookings"
      >
        <div class="card booking-card">
          <div class="card-header info-sec-header flex-wrap flex-md-nowrap">
            <h4 class="info-sec-heading mb-md-0 mb-2">
              Open Bookings
            </h4>
            <div class="d-flex flex-wrap justify-content-end">
              <date-picker
                v-model="openBookingsFrom"
                input-class="date-input date-filter"
                format="DD/MM/YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                :lang="lang"
              />
              <date-picker
                v-model="openBookingsTo"
                input-class="date-input date-filter"
                format="DD/MM/YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                :lang="lang"
              />
              <button
                class="btn btn-primary small-button info-sec-header-space"
                @click="cleanBookingsDateFilter"
              >
                <i class="fa fa-calendar-times"/>
              </button>
              <form class="mr-3">
                <b-input
                  v-model="bookingsSearch"
                  debounce="300"
                  class="form-control small-control info-sec-header-space"
                  placeholder="Search bookings..."
                />
              </form>
              <b-button
                class="small-button info-sec-header-space"
                variant="primary"
                @click="openBookingModal"
              >
                + New Booking
              </b-button>
              <booking-modal
                :value="bookingToEdit"
                :value-copy-from="bookingCopyFrom"
                :open="bookingModalOpen"
                :clear-booking-callback="clearBooking"
                @modal-closed="onBookingModalClose"
              />
            </div>
          </div>
          <div class="booking-table-wrapper">
            <table class="table table-striped narrow-rows">
              <thead>
              <tr>
                <th scope="col">
                  Date
                </th>
                <th scope="col">
                  Customer
                </th>
                <th scope="col">
                  #
                </th>
                <th scope="col">
                  From
                </th>
                <th scope="col">
                  To
                </th>
                <th scope="col">
                  Notes
                </th>
                <th scope="col"/>
              </tr>
              </thead>

              <template v-for="(openBookings,date) in openBookingsByDate">
                <tr
                  :key="`tr-${date}`"
                  class="no-pointer table-secondary"
                >
                  <th colspan="7">
                    {{ date }}
                  </th>
                </tr>
                <draggable
                  :key="`draggable-${date}`"
                  tag="tbody"
                  :list="openBookings"
                  :sort="false"
                  group="bookings"
                  @change="onBookingsChange"
                >
                  <tr
                    v-for="openBooking in openBookings"
                    :key="openBooking.bookingCarId"
                    :class="{'table-primary': (activeBooking && openBooking.id === activeBooking.id)}"
                    @click="onOpenBookingClick(openBooking)"
                  >
                    <th
                      scope="row"
                      :class="{'bg-danger':bookingsShouldBeAlerted[openBooking.id]}"
                    >
                      {{ openBooking.date | formatDateLeadingTime }}
                    </th>
                    <td>{{ openBooking.passengerName }}</td>
                    <td :style="{'background':openBooking.carType.colourCode}">
                      {{ openBooking.passengersCount }}
                    </td>
                    <td :class="{'via':openBooking.hasViaAddress}">
                      {{ openBooking.addressFrom | formatAddress }}
                    </td>
                    <td>{{ openBooking.addressTo | formatAddress }}</td>
                    <td>{{ openBooking.driverNote }}</td>
                    <td >
                      <div style="min-width: 45px;">
                      <a
                        href="#"
                        class="table-edit"
                        @click.stop="editBooking(openBooking)"
                      >
                        <i class="fa fa-external-link-alt"/>
                      </a>
                      <a
                          href="#"
                          class="table-copy"
                          @click.stop="copyBooking(openBooking)"
                      >
                        <i class="fa fa-copy"/>
                      </a>
                      <a
                        href="#"
                        class="table-delete"
                        @click.stop="deleteBooking(openBooking)"
                      >
                        <i class="fa fa-trash-alt"/>
                      </a>
                      </div>
                    </td>
                  </tr>
                </draggable>
              </template>
            </table>
          </div>
        </div>
      </div>
    </div>
    <car-edit-modal
      v-model="activeCar"
      :open="editCarModalOpen"
      @modal-closed="onCarEditModalClosed"
    />
  </layout-basic>
</template>

<script>
  import LayoutBasic from "@/layouts/LayoutBasic";
  import CarModal from "@/components/CarModal";
  import BookingModal from "@/components/BookingModal";
  import DispatchModal from "@/components/DispatchModal";
  import {mapGetters} from "vuex";
  import CarCard from '../components/home/CarCard'
  import moment from 'moment'
  import draggable from 'vuedraggable'
  import constants from '../utils/Constants'
  import Multiselect from 'vue-multiselect'
  import DashboardHubMixin from "../mixins/DashboardHubMixin";
  import CarEditModal from "../components/CarEditModal";
  import DatePicker from "vue2-datepicker"
  import 'vue2-datepicker/locale/en';

  export default {
    name: "Home",
    mixins: [DashboardHubMixin],
    computed: {
      ...mapGetters(['selectedHeaderEvent', 'viewSelection']),
      bookingsShouldBeAlerted() {
        let vm = this;
        let total = {};
        this.bookings.forEach(openBooking => {
          let bookingDay = moment.utc(openBooking.date);
          let duration = moment.duration(bookingDay.diff(vm.timeNowUtc));
          let minutes = duration.asMinutes();
          total[openBooking.id] = minutes <= openBooking.timeAlertInMinutes;
        });
        return total;
      },
    },
    components: {
      LayoutBasic,
      CarModal,
      BookingModal,
      DispatchModal,
      CarCard,
      draggable,
      Multiselect,
      CarEditModal,
      DatePicker
    },
    watch: {
      activeCarId: function () {
        let vm = this;
        this.activeCar = this.cars.filter(c => c.id === vm.activeCarId)[0];
        this.changeActiveCarBookings();
      },
      filter: {
        handler: async function () {
          await this.getData();
        },
        deep: true
      },
      selectedHeaderEvent: async function () {
        this.activeCar = null;
        this.activeCarId = null;
        this.activeBooking = null;
        await this.getData();
      },
      async $route(to, from) {
        if (to.name === 'home') {
          await this.getData();
        }
      },
      bookingsSearch: async function () {
        await this.getData();
      },
      carSearch: async function () {
        await this.getData();
      },
      openBookingsFrom: async function () {
        await this.getData();
      },
      openBookingsTo: async function () {
        await this.getData();
      }
    },
    data() {
      return {
        cars: [],
        filter: {
          isWorking: true,
          carType: null,
          dispatchStatus: -1,
        },
        dispatchModalForm: {
          driver: '',
          phone: '',
          message: '',
          bookingId: '',
        },
        carSearch: '',
        dispatchModalOpen: false,
        bookings: [],
        openBookings: [],
        openBookingsByDate: {},
        openBookingsFrom: null,
        openBookingsTo: null,
        timeNow: moment(),
        timeNowUtc: moment.utc(),
        draggingBookingId: '',
        bookingsDraggedOnCars: {},
        activeCarId: '',
        activeCar: null,
        editCarModalOpen: false,
        activeCarBookings: [],
        carTypes: [],
        constants: constants,
        bookingsByCars: {},
        dispatchStatuses: [],
        activeBooking: null,
        bookingToEdit: null,
        bookingModalOpen: false,
        bookingCopyFrom: null,
        bookingsSearch: '',
        lang: {
          formatLocale: {
            firstDayOfWeek: 1,
          },
          monthBeforeYear: false,
        }
      }
    },
    created: async function () {
      this.dispatchStatuses = [-1].concat(Object.values(constants.bookingDispatchStatus))
      await this.getData();
      await this.connectDashboardHub();
      setInterval(() => {
        this.timeNow = moment()
        this.timeNowUtc = moment.utc()
      }, 1000 * 15)
    },
    methods: {
      async searchDebounce() {
        await this.getData();
      },
      async handleBookingUpdate() {
        await this.getData();
      },
      async getData() {
        try {
          let vm = this;
          if (this.carTypes.length === 0) {
            this.carTypes = (await this.$http.get('carTypes')).data
            this.carTypes.unshift({type: 'All', colourCode: '#fffffff'})
          }

          let carsResponse = await this.$http.get(`cars?limit=100&searches[isWorking]=${this.filter.isWorking}&searches[eventId]=${this.selectedHeaderEvent}${this.filter.carType ? '&searches[carTypeId]=' + this.filter.carType.id : ''}${this.carSearch ? '&search=' + this.carSearch : ''}`);
          this.cars = carsResponse.data.items;
          this.cars.sort((car1, car2) => {
            if (car1.driver.firstName.toLowerCase() + car1.driver.lastName.toLowerCase() >
              car2.driver.firstName.toLowerCase() + car2.driver.lastName.toLowerCase()) {
              return 1;
            } else {
              return -1;
            }
          });
          if (this.cars.filter(c => c.id === vm.activeCarId).length === 0) {
            vm.activeCarId = null;
          }
          this.activeCar = this.cars.filter(c => c.id === vm.activeCarId)[0];

          this.bookingsDraggedOnCars = {};
          this.cars.forEach(car => {
            this.bookingsDraggedOnCars[car.id] = []
          });
          let bookingsResponse = await this.$http.get(`bookings?limit=10000&searches[eventId]=${this.selectedHeaderEvent}`);
          this.bookings = bookingsResponse.data.items;
          let tempOpenBookings = [];
          let tempOpenBookingsByDate = {};
          this.bookings.forEach(booking => {
            if (booking.carId || !booking.passengerName.toLowerCase().includes(this.bookingsSearch.toLowerCase())) {
              return
            }
            if (this.openBookingsFrom && moment.utc(this.openBookingsFrom).set({
              hour: 0,
              minute: 0,
              second: 0
            }).isAfter(moment.utc(booking.date))) {
              return;
            }
            if (this.openBookingsTo && moment.utc(this.openBookingsTo).set({
              hour: 23,
              minute: 59,
              second: 59
            }).isBefore(moment.utc(booking.date))) {
              return;
            }
            let hasViaAddress = booking.viaAddress1.address1 || booking.viaAddress1.address2 ||
              booking.viaAddress1.town || booking.viaAddress1.postCode || booking.viaAddress2.address1 || booking.viaAddress2.address2 ||
              booking.viaAddress2.town || booking.viaAddress2.postCode;
            let openBooking = booking;
            openBooking.hasViaAddress = hasViaAddress;
            tempOpenBookings.push(openBooking);
            let bookingDate = vm.$options.filters.formatOnlyDateWithDayOfWeek(openBooking.date);
            if (!tempOpenBookingsByDate.hasOwnProperty(bookingDate)) {
              tempOpenBookingsByDate[bookingDate] = [];
            }
            tempOpenBookingsByDate[bookingDate].push(openBooking);
          });
          this.openBookings = tempOpenBookings;
          this.openBookingsByDate = tempOpenBookingsByDate;
          this.mapCarBookings();
          if (this.filter.dispatchStatus > -1) {
            this.cars = this.cars.filter(car => {
              let earliestBooking = vm.bookingsByCars[car.id] ? vm.bookingsByCars[car.id][0] : null;
              return earliestBooking && earliestBooking.dispatchStatus === vm.filter.dispatchStatus;
            })
          }
          this.changeActiveCarBookings();
        } catch (error) {
          this.handleErrorResponse(error)
        }
      },
      mapCarBookings() {
        this.bookingsByCars = {}
        for (let car of this.cars) {
          this.bookingsByCars[car.id] = this.bookings.filter(booking => {
            return booking.carId === car.id && booking.status !== constants.bookingStatus.Cleared
          });
          this.bookingsByCars[car.id].sort((a, b) => {
            return a.date >= b.date ? 1 : -1;
          })
        }
      },
      changeActiveCarBookings() {
        if (!this.activeCarId) {
          this.activeCarBookings = [];
          return;
        }
        this.activeCarBookings = [...this.bookingsByCars[this.activeCarId]];
        if (this.activeCarId && this.activeBooking) {
          this.activeCarBookings.unshift(this.activeBooking);
        }
      },
      async onCarModalClose() {
        await this.getData();
      },
      async allocateBooking(booking) {
        try {
          await this.$http.post(`bookings/${booking.id}/allocate/${this.activeCarId}`);
          this.activeBooking = null;
        } catch (error) {
          this.handleErrorResponse(error)
        }
        await this.getData();
      },
      async deallocateBooking(booking) {
        try {
          await this.$http.post(`bookings/${booking.id}/deallocate`);
        } catch (error) {
          this.handleErrorResponse(error)
        }
        await this.getData();
      },
      async onBookingsChange(evt) {
        if (evt.hasOwnProperty('removed')) {
          return
        }
        try {
          for (let carId in this.bookingsDraggedOnCars) {
            for (let booking of this.bookingsDraggedOnCars[carId]) {
              let result = await this.$http.post(`bookings/${booking.id}/allocate/${carId}`);
              this.bookingsDraggedOnCars[carId] = [];
              this.activeCarId = carId;
              if (this.activeBooking?.id === booking.id) {
                this.activeBooking = null;
              }
            }
          }
        } catch (error) {
          this.handleErrorResponse(error)
        }
        this.getData();
      },
      dispatchModal(booking) {
        let vm = this;
        this.dispatchModalForm.bookingId = booking.id
        this.dispatchModalForm.driver = `${vm.activeCar.driver.firstName} ${vm.activeCar.driver.lastName}`
        this.dispatchModalForm.phone = `${vm.activeCar.driver.phoneNumber}`
        let addressText = `From: ${this.$options.filters.formatAddress(booking.addressFrom)}\n`;
        addressText += `To: ${this.$options.filters.formatAddress(booking.addressTo)}\n`;
        if (!this.isAddressEmpty(booking.viaAddress1)) {
          addressText += `Via 1: ${this.$options.filters.formatAddress(booking.viaAddress1)}\n`;
        }
        if (!this.isAddressEmpty(booking.viaAddress2)) {
          addressText += `Via 2: ${this.$options.filters.formatAddress(booking.viaAddress2)}\n`;
        }
        let generalText = `${this.$options.filters.formatDate(booking.date)}\nName: ${booking.passengerName}\n`;
        if (booking.flyingFrom){
          addressText += `Origin Airport: ${booking.flyingFrom}\n`
        }
        if (booking.flightNumber){
          addressText += `Flight: ${booking.flightNumber}\n`
        }
        this.dispatchModalForm.message = `${generalText}${addressText}Note: ${booking.driverNote}`
        this.dispatchModalOpen = true;
      },
      isAddressEmpty(address) {
        return address.address1 === '' && address.address2 === '' &&
          address.town === '' && address.postCode === ''
      },
      async clearBooking(booking) {
        try {
          await this.$http.post(`bookings/${booking.id}/clear`);
          this.successAlert("The booking was successfully cleared.");
        } catch (error) {
          this.handleErrorResponse(error)
        }
      },
      async onCarWorkingChange(car) {
        car.isWorking = !car.isWorking;
        try {
          car.driver = null;
          car.carType = null;
          await this.$http.put(`cars/${car.id}`, car);
          await this.getData();
        } catch (error) {
          this.handleErrorResponse(error)
        }
      },
      async onCarEditModalClosed() {
        this.editCarModalOpen = false;
        await this.getData();
      },
      async deleteActiveCar() {
        try {
          let confirmation = await this.$bvModal.msgBoxConfirm('Are you sure you want to delete this car?', {
            okVariant: 'danger',
            okTitle: 'Delete',
          });
          if (!confirmation) return;
          await this.$http.delete(`cars/${this.activeCarId}`);
          this.activeCarId = undefined;
          await this.getData();
        } catch (error) {
          this.handleErrorResponse(error);
        }
      },
      toggleCarCard(carId) {
        if (this.activeCarId === carId) {
          this.activeCarId = undefined;
          return;
        }
        this.activeCarId = carId
      },
      onOpenBookingClick(booking) {
        if (this.activeBooking && this.activeBooking.id === booking.id) {
          this.activeBooking = null;
        } else {
          this.activeBooking = booking;
        }
        this.changeActiveCarBookings();
      },
      editBooking(booking) {
        this.bookingToEdit = booking;
        this.bookingCopyFrom = null;
        this.bookingModalOpen = true;
      },
      copyBooking(booking){
        this.bookingToEdit = null;
        this.bookingCopyFrom = booking;
        this.bookingModalOpen = true;
      },
      async onBookingModalClose() {
        this.bookingModalOpen = false;
        await this.getData();
      },
      openBookingModal() {
        this.bookingToEdit = null;
        this.bookingCopyFrom = null;
        this.bookingModalOpen = true;
      },
      async deleteBooking(booking) {
        try {
          let confirmation = await this.$bvModal.msgBoxConfirm('Are you sure you want to delete this booking?', {
            okVariant: 'danger',
            okTitle: 'Delete',
          });
          if (!confirmation) return;
          await this.$http.delete(`bookings/${booking.id}`);
          if (this.activeBooking && booking.id === this.activeBooking.id) {
            this.activeBooking = null;
          }
          await this.getData();
        } catch (error) {
          this.handleErrorResponse(error);
        }
      },
      cleanBookingsDateFilter() {
        this.openBookingsTo = null;
        this.openBookingsFrom = null;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/variables.scss";
  @import "bootstrap/scss/_functions.scss";
  @import "bootstrap/scss/_variables.scss";
  @import "bootstrap/scss/_mixins.scss";

  //Hack to hide dragging item on cars container
  .cars-container {
    tr {
      display: none !important;
    }
  }

  .fake-handle {
    visibility: hidden;
  }

  .maxWidthMinHeight {
    max-width: 1600px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    height: 100%;
    justify-content: stretch;
  }

  .card-header {
    &.info-sec-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 4px 12px 4px 12px;
      flex-shrink: 0;

      @include media-breakpoint-down(md) {
        flex-wrap: wrap;
      }
    }
  }

  .card {
    &.car-active {
      height: 100%;
    }
  }

  .header-control-wrapper {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;

    @include media-breakpoint-down(sm) {
      justify-content: flex-start;
    }
  }

  .info-sec-header-space {
    margin: 2px 8px 2px 8px;

    &.fb-100 {
      flex-basis: 190px;
      flex-grow: 1;
      flex-shrink: 0;
    }

  }

  .cars-container {
    height: 150px;
    overflow: auto;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    grid-gap: 8px;
    align-content: start;
    padding: 4px 4px 4px 4px;

    &.car-active {
      height: 100%;
    }

    &.cars-two-rows {
      height: 300px;
    }
  }

  /deep/ .btn {
    &.dropdown-toggle {
      &.btn-outline-dark {
        padding: 0px;
      }
    }
  }

  .small-control {
    height: auto;
    padding-top: 2px;
    padding-bottom: 2px;
    width: 100%;
  }

  .small-button {
    padding-top: 0px;
    padding-bottom: 2px;
  }

  .info-section {
    margin-top: 16px;
    flex-grow: 0;
    display: block;

    &.bookings {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
    }

    &.car-active {
      overflow: auto;
      flex-basis: 100%;
      flex-grow: 1;
    }
  }

  .info-sec-heading {
    margin-bottom: 0px;
    margin-left: 8px;
    flex-basis: 80px;
    flex-shrink: 0;
    flex-grow: 1;
  }

  /deep/ .booking-card {
    .info-sec-heading {

      flex-basis: 180px;
    }
  }

  .form-control-lg {
    padding-right: 6px !important;
  }

  .alloc-container {
    padding: 8px 8px 8px 8px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(380px, 450px));
    grid-template-rows: repeat(auto-fill, minmax(110px, auto));
    grid-gap: 8px;
    max-height: 155px;
    overflow: auto;

    @include media-breakpoint-only(xs) {
      grid-template-columns: auto;
    }
  }

  .alloc-card {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    background-color: rgba(0, 0, 0, 0.03);

    &.accepted {
      background-color: $alloc-accepted;
    }
  }

  .alloc-info {
    width: 100%;
    display: grid;
    grid-template-columns: 160px auto 20px;;
    grid-template-rows: auto auto auto;
    grid-gap: 7px;
    padding: 10px 10px 10px 10px;

    @include media-breakpoint-only(xs) {
      grid-template-columns: auto;
    }
  }

  .alloc-actions {
    background-color: white;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: stretch;
    padding: 10px 10px 10px 10px;
    border-left: 1px solid rgba(0, 0, 0, 0.125);
  }

  .alloc-item {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    line-height: 18px;

    i {
      color: $dark-grey;
      width: 20px;
      margin-top: 1px;
      margin-right: 6px;
    }

    &.time {
      padding-right: 8px;
    }

    &.address {
      grid-column: 1 / span 2;

      @include media-breakpoint-only(xs) {
        grid-column: 1;
      }
    }
  }

  .booking-card {
    flex-basis: 150px;
    flex-grow: 1;
    flex-shrink: 0;
    overflow: hidden;

    @include media-breakpoint-down(sm) {
      flex-basis: 300px;
    }
  }

  .booking-table-wrapper {
    overflow-y: auto;
  }

  .narrow-rows {
    th {
      padding-top: 4px;
      padding-bottom: 4px;
    }

    td {
      padding-top: 4px;
      padding-bottom: 4px;
    }
  }

  thead th {
    position: sticky;
    top: 0;
    background-color: $white;
    border: none;
    box-shadow: 0px 1px 0 #dee2e6;
  }

  td {
    &.via {
      background-color: $via;
    }
  }

  th {
    &.bg-danger {
      color: $white;
    }
  }

  .table-edit {

    margin-left: 3px;
    margin-right: 3px;

    &.alloc {
      margin-top: -2px;
    }

    i {
      color: $info;
    }

    &:hover {
      color: currentColor;
    }

  }

  .table-delete {
    margin-left: 3px;
    margin-right: 3px;

    i {
      color: $danger;
    }

    &:hover {
      color: currentColor;
    }
  }

  .table-copy {
    margin-left: 3px;
    margin-right: 3px;

    i {
      color: $success;
    }

    &:hover {
      color: currentColor;
    }
  }

  .car-type {
    margin-right: 8px;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    border-radius: 50px;
    border: solid 1px $border-grey;
  }

  .car-type-dropdown, .car-status-dropdown {
    flex-basis: 155px;
    flex-grow: 1;
    flex-shrink: 0;

    .multiselect {
      min-width: 155px;
      min-height: unset !important;

    }
  }

  .car-type-dropdown::v-deep, .car-status-dropdown::v-deep .multiselect {

    height: 30px;

    .multiselect__tags {
      min-height: unset !important;
      height: 30px;
      padding-top: 2px;
      border: 1px solid $border-grey;
    }

    .multiselect__single {
      margin-bottom: 2px;
      font-size: 1rem;
    }

    .multiselect__placeholder {
      margin-bottom: 2px;
      padding-top: 0px;
      color: $placeholder-grey;
      font-size: 1rem;
    }

    .multiselect__select {
      height: 30px;
    }

  }

  .car-status-dropdown::v-deep .multiselect {

    .multiselect__single {
      .car-msg-status {
        padding: 1px 6px 1px 6px;
        margin-top: 0px;
        margin-right: 8px;
        margin-bottom: 0px;
        line-height: 20px;
      }

      div {
        span {
          padding-top: 2px;
        }
      }
    }

    .multiselect__content-wrapper {
      .multiselect__content {
        .multiselect__element {
          .multiselect__option {
            min-height: unset !important;

            div {
              .car-msg-status {
                padding: 1px 6px 1px 6px;
                margin-bottom: 0px;
                line-height: 20px;
                margin-right: 8px;
              }

              span {
                padding-top: 4px;
              }
            }
          }
        }
      }
    }
  }


  .cars-dropdown /deep/ .dropdown-menu .dropdown-item {
    display: flex;
    align-items: center;

    .car-msg-status {
      margin-top: 0px;
      margin-right: 6px;
    }
  }

  .cars-dropdown /deep/ .dropdown-menu {
    width: 100%;
  }

  .cars-dropdown /deep/ .dropdown-toggle {
    padding-left: 9px;
    padding-right: 9px;
  }

  tr {
    &:hover {
      cursor: pointer;
    }
  }

  .no-pointer {
    &:hover {
      cursor: default !important;
    }
  }


  /deep/ .mx-datepicker {
    margin-top: 2px;
    margin-left: 8px;
    width: none;
    flex: 0 0 130px;

    .date-input {
      line-height: 24px;
    }
  }


</style>
